// ----- Imports ----- //
import * as cookie from 'helpers/storage/cookie';
// ----- Functions ----- //
function getUser() {
    if (window.guardian.user && window.guardian.user.email !== '') {
        const { firstName, lastName, email } = window.guardian.user;
        return {
            firstName: typeof firstName === 'string' ? firstName : undefined,
            lastName: typeof lastName === 'string' ? lastName : undefined,
            email: typeof email === 'string' ? email : undefined,
            isSignedIn: true,
        };
    }
    return {
        isSignedIn: false,
    };
}
function isTestUser() {
    const isDefined = (x) => x !== null && x !== undefined;
    const testMode = window.guardian.testMode;
    const testCookie = cookie.get('_test_username');
    return isDefined(testMode) || isDefined(testCookie);
}
const isPostDeployUser = () => cookie.get('_post_deploy_user') === 'true';
// ----- Exports ----- //
export { getUser, isTestUser, isPostDeployUser };
